import { render, staticRenderFns } from "./CodePicker.vue?vue&type=template&id=0b83de10&scoped=true"
import script from "./CodePicker.vue?vue&type=script&lang=js"
export * from "./CodePicker.vue?vue&type=script&lang=js"
import style0 from "./CodePicker.vue?vue&type=style&index=0&id=0b83de10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b83de10",
  null
  
)

export default component.exports